import React, { useState } from "react";
// reactstrap components
import {
    Card,
    CardBody,
    CardTitle,
    CardText,
    FormGroup,
    Label,
    Button,
    Input,
    Container,
    Row,
    Col,
    Modal,
    ModalBody,
    Alert
} from "reactstrap";
import Datetime from 'react-datetime';
// core components
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
import { handleResponse, authHeader } from '_helpers';
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader2.js";
import DarkFooter from "components/Footers/DarkFooter.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import TSUpload from "components/Forms/TSUpload2.js";
import TSText from "components/Forms/TSText.js";

import { useDropzone } from 'react-dropzone'
import 'assets/css/react-datetime.css'
import Resizer from 'react-image-file-resizer';

const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16
};

const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: 'border-box'
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
};

const img = {
    display: 'block',
    width: 'auto',
    height: '100%'
};


const TelePage = (props) => {

    const liffId = {
        tele: '1654063801-PwXBy90W', tele2: '1654063801-2Na3K7jR'
    }
    var _liffid = "";
    if (props.location.pathname == '/tele')
        _liffid = liffId.tele
    else if (props.location.pathname == '/tele2')
        _liffid = liffId.tele2

    var moment = require('moment');
    require('moment/locale/th');

    const arrServiceType = [
        { ServiceType: 1, ServiceTypeText: 'พบแพทย์' },
        { ServiceType: 2, ServiceTypeText: 'รับยาเดิม' },
        { ServiceType: 5, ServiceTypeText: 'พบแพทย์(2)' }
        ];

    const [dateFocus, setDateFocus] = useState(false);
    const [errMsg, setErrMsg] = useState(false);
    const [modalError, setModalError] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [modalNote, setModalNote] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");

    const [modalHoliday, setModalHoliday] = useState(false);
    const [holidayText, setHolidayText] = useState('');
    const [currentDate, setcurrentDate] = useState(moment());
    const [holidays, setHolidays] = useState([]);
    const [isNewPatient, setIsNewPatient] = useState(false);

    const [ServiceType, setType] = useState("");
    const [ServiceTypeText, setTypeText] = useState("");
    const [AppointDatetime, setAppointDatetime] = useState("");
    const [AppointDate, setAppointDate] = useState("");
    const [AppointTime, setAppointTime] = useState("");
    const [SlotType, setSlotType] = useState(0);
    const [renderButton, setRenderButton] = useState([]);

    const [Phone, setPhone] = useState("");
    const [LineID, setLine] = useState("");
    const [ShippingAddress, setAddress] = useState("");
    const [DefAddress, setDefAddress] = useState("");
    const [Description, setDescription] = useState("");
    const [FullName, setFullName] = React.useState("");
    const [isCheckedAddress, setIsCheckedAddress] = React.useState(false);
    const [isRecheckTime, setIsRecheckTime] = React.useState(false);
    const [files, setFiles] = useState([]);
    const [displayNoTime, setDisplayNoTime] = useState(false);

    

    const buttonContent = renderButton.map((post, index) =>
        <Button key={index} color={(post.slotTime == AppointTime ? "success" : "info")} size="sm" style={{ width: '75px', fontSize:'15px' }} onClick={e => handleTimeSelect(post.slotTime)}> {post.slotTime.substring(0, 5)}</Button >
    );

    const handleTimeSlot = (date) => {
        setAppointDate(date);
        setAppointTime("") 
        setRenderButton([]);
        fetch('/api/v1/tele/timeslot?AppointDatetime=' + date + '&SlotType=' + SlotType, {
            method: 'GET',
            headers: authHeader()
        })
            .then(handleResponse)
            //.then(response => response.json())
            .then(
                (result) => {
                    setRenderButton(result.data);

                   setDisplayNoTime(result.data != null && result.data.length == 0); 
                 

                },
                (error) => {
                    alert(error);
                }
            );
    }


    const handleTimeSelect = (time) => {
        setAppointTime(time);
        setAppointDatetime(AppointDate + ' ' + time)
    }

    const handleServiceType = (sType) => {
        setType(sType);
        //setTypeText((sType == 1) ? 'พบแพทย์' : 'รับยา')
        var ast = arrServiceType.filter(u => u.ServiceType == sType)[0].ServiceTypeText;
        setTypeText(ast);

        var slot = 0;

        if (sType == 1)
            slot = 4;
        else if (sType == 2)
            slot = 5;
        else if (sType == 5)
            slot = 6;

        setSlotType(slot)
        setAppointTime("")
        if (AppointDate != null && AppointDate != '') {
            setRenderButton([]);
            fetch('/api/v1/tele/timeslot?AppointDatetime=' + AppointDate + '&SlotType=' + slot, {
                method: 'GET',
                headers: authHeader()
            })
                .then(handleResponse)
                //.then(response => response.json())
                .then(
                    (result) => {
                        setRenderButton(result.data);
                        setDisplayNoTime(result.data != null && result.data.length == 0);
                    },
                    (error) => {
                        alert(error);
                    }
                );
        }
    }



    const liff = window.liff;
        liff.init({
            //liffId: '1654063801-PwXBy90W'
            liffId: _liffid
        })
        .then(() => {

            if (liff.isLoggedIn()) {
                
                liff.getProfile().then(function (profile) {

                    authenticationService.login(profile.userId, profile.userId)
                        .then(
                            user => {
                                //const { from } = this.props.location.state || { from: { pathname: "/home" } };
                                //this.props.history.push(from);
                                //window.alert(user)
                            },
                            error => {
                                console.log(error);
                            }
                    );

                }).catch(function (error) {
                    window.alert('Error getting profile: ' + error);
                });
                
            }
        })
        .catch((err) => {

        });

        React.useEffect(() => {
            console.log(props);

            fetch('/api/v1/profile/address', {
                method: 'GET',
                headers: authHeader()
            })
            .then(handleResponse)
            //.then(response => response.json())
            .then(
                (result) => {
                    console.log(result)
                    setPhone(result.phone)

                    //setAddress(result.fullAddress)
                    setDefAddress(result.fullAddress)
                    setFullName(result.fullName)
                    setIsNewPatient(result.isNewPatient)

                    if (result.isNewPatient) {
                        setType(1);
                        setSlotType(4);
                    }
                        
                },
                (error) => {
                    alert(error);
                }
            );

            fetchHoliday(moment().format('YYYY/M'));
            /*
            fetch('/api/holiday/' + moment().format('YYYY/M'), {
                method: 'GET',
                headers: authHeader()
            })
            .then(handleResponse)
            //.then(response => response.json())
            .then(
                (result) => {
                    console.log(result)
                    setHolidays(result.data)
                },
                (error) => {
                    alert(error);
                }
            );
            */

        document.body.classList.add("landing-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        setModalNote(true);
        return function cleanup() {
            document.body.classList.remove("landing-page");
            document.body.classList.remove("sidebar-collapse");
        };  
    }, []);



    

    var fileTxt = "";



    const handleClear = (evt) => {
        evt.preventDefault();
        setFiles([]);
    }
    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/*',
        onDrop: acceptedFiles => {
            acceptedFiles.map(file =>
                setFiles(f => [...f, Object.assign(file, { preview: URL.createObjectURL(file) })])
            )    
            /*
            setFiles(
                
                acceptedFiles.map(file =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file)
                    })
                )

            );
            */
        },
        
    });

    const thumbs = files.map(file => (
        <div style={thumb} key={file.name}>
            <div style={thumbInner}>
                <img
                    src={file.preview}
                    style={img}
                />
            </div>
        </div>
    ));

    async function uploadWithJSON(file) {
        

        const toBase64 = file => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });

        const toBase64Resize = (file2) => new Promise(resolve => {
            var compressType;

            if (file2.type == 'image/jpeg')
                compressType = 'JPEG';
            else if (file2.type == 'image/png')
                compressType = 'PNG';
            else if (file2.type == 'image/webp')
                compressType = 'WEBP';

            Resizer.imageFileResizer(file2, 1000, 1000, compressType, 100, 0,
                uri => {
                    resolve(uri);
                },
                'base64'
            );
        });
        //console.log(file)

        const data = {
            fileName: file.name,
            fileSize: file.size,
            fileType: file.type,
            fileBase64: await toBase64Resize(file),
            //fileBase64: await toBase64(file),
        }

        return await data;
    }

    const handleSubmit = (evt) => {
        evt.preventDefault();

        console.log(files)

        var cntErr = 0;
        var errMsg = '';


        if (Description == null || Description == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุความต้องการ หรือ อาการเบื้องต้น';
        }

        if (!isCheckedAddress && (ShippingAddress == null || ShippingAddress == '')) {
            cntErr += 1;
            errMsg = 'กรุณาระบุที่อยุ่จัดส่งยาทางไปรษณีย์';
        }

        if (isCheckedAddress && (DefAddress == null || DefAddress == '')) {
            cntErr += 1;
            errMsg = 'กรุณาระบุที่อยุ่จัดส่งยาทางไปรษณีย์';
        }

        if (Phone == null || Phone == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุหมายเลขโทรศัพท์';
        }


        if (!moment(AppointDatetime).isValid()) {
            cntErr += 1;
            errMsg = 'กรุณาระบุวันที่ต้องการรับบริการ';
        }
        else {
            if (ServiceType == 1 && moment(AppointDatetime).format("DD/MM/YYYY") == moment(new Date()).format("DD/MM/YYYY") && moment().hour() >= 10) {
                cntErr += 1;
                errMsg = 'การพบแพทย์กรุณาทำรายการก่อน 11.00 น. หรือ เลือกวันถัดไป';
            } else if (ServiceType == 2 && moment(AppointDatetime).format("DD/MM/YYYY") == moment(new Date()).format("DD/MM/YYYY") && moment().hour() >= 15) {
                cntErr += 1;
                errMsg = 'การรับยาเดิมกรุณทำรายการก่อน 15.00 น. หรือ เลือกวันถัดไป';
            }
        }


        if (AppointTime == null || AppointTime == '') {
            cntErr += 1;
            errMsg = 'กรุณาเลือกเวลานัดหมาย';
        }

        if (ServiceType == null || ServiceType == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุความต้องการ พบแพทย์หรือรับยาต่อเนื่อง';
        }

        if (ServiceType == 1 && files.length < 4) {
            cntErr += 1;
            errMsg = 'การพบแพทย์กรุณาแนบรูปอาการอย่างน้อย 4 รูป';
        }

  
        if (cntErr > 0) {
            setErrMsg(errMsg);
            setModalError(true);
        }
        else {
            setModal2(true);
        }     
    }

    const handleConfirm = (evt) => {
        evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

        fetch('/api/v1/tele/timeslot?AppointDatetime=' + AppointDate + '&SlotType=' + SlotType, {
            method: 'GET',
            headers: authHeader()
        })
            .then(handleResponse)
            //.then(response => response.json())
            .then(
                (resultValid) => {
                    var validate = resultValid.data.find(s => s.slotTime == AppointTime);

                    //ถ้า Recheck แล้วยังว่าง
                    if (validate != null) {







                        
                        //alert(currentUser.fullName);

                        //alert(`Submitting Type ${ServiceType} Date ${AppointDatetime} LineID ${LineID}, Phone ${Phone}, ShippingAddress ${ShippingAddress}, Description ${Description} `)

                        const requestOptions = {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json-patch+json',
                                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
                            },
                            body: JSON.stringify({
                                "serviceType": ServiceType,
                                "appointDatetime": AppointDatetime,
                                "appointDate": AppointDate,
                                "appointTime": AppointTime,
                                "lineID": LineID,
                                "phone": Phone,
                                "shippingAddress": (isCheckedAddress) ? DefAddress : ShippingAddress/*ShippingAddress*/,
                                "description": Description,
                            })
                        };

                        fetch('/api/v1/tele', requestOptions)
                            .then(handleResponse)
                            .then(
                                (result) => {
                                    //console.log(result);

                                    //console.log(files);
                                    var totalFile = files.length;
                                    if (totalFile > 0) {
                                        files.map((file, index) => {
                                            const prom = uploadWithJSON(file);
                                            Promise.resolve(prom).then((e) => {
                                                //console.log(e);
                                                const reqOpt = {
                                                    method: 'POST',
                                                    headers: {
                                                        'Content-Type': 'application/json-patch+json',
                                                        'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
                                                    },
                                                    body: JSON.stringify({
                                                        "teleID": result.data.teleID,
                                                        "fileName": e.fileName,
                                                        "fileCategoryID": 0,
                                                        "fileType": e.fileType,
                                                        "fileSize": e.fileSize,
                                                        "fileBase64": e.fileBase64,
                                                    })
                                                };

                                                fetch('/api/v1/tele/upload', reqOpt)
                                                    .then(handleResponse)
                                                    .then(
                                                        (result) => {
                                                            //console.log(result);
                                                            //alert(result.data.fileID)
                                                            if (index == (totalFile - 1)) {
                                                                if (liff.isInClient()) {
                                                                    liff.sendMessages([{
                                                                        'type': 'text',
                                                                        'text': `#ยืนยันการลงทะเบียน${ServiceTypeText}  - ${currentUser.fullName} ${AppointDatetime}`
                                                                    }]).then(function () {
                                                                        liff.closeWindow();
                                                                    }).catch(function (error) {
                                                                        window.alert('Error sending message: ' + error);
                                                                    });


                                                                } else {
                                                                    const { from } = props.location.state || { from: { pathname: "/home" } };
                                                                    props.history.push(from);
                                                                }
                                                            }
                                                        },
                                                        (error) => {
                                                            console.log(error);
                                                            alert(error)
                                                        }
                                                    )
                                            });
                                        });
                                    }
                                    else {
                                        if (liff.isInClient()) {

                                            liff.sendMessages([{
                                                'type': 'text',
                                                'text': `#ยืนยันการลงทะเบียน${ServiceTypeText}  - ${currentUser.fullName} ${AppointDatetime}`
                                            }]).then(function () {
                                                liff.closeWindow();
                                            }).catch(function (error) {
                                                window.alert('Error sending message: ' + error);
                                            });


                                        } else {
                                            const { from } = props.location.state || { from: { pathname: "/home" } };
                                            props.history.push(from);
                                        }
                                    }
                                    //setId(result.data.teleID);
                                    //setModal2(true);

                                    //bug อยู่  ต้องรอให้ upload เสร็จก่อน ถึงจะปิดจอ
                                    /*
                                    if (liff.isInClient()) {
                
                                        liff.sendMessages([{
                                            'type': 'text',
                                            'text': '#ยืนยันการจอง'
                                        }]).then(function () {
                                            //window.alert('Message sent');
                                        }).catch(function (error) {
                                            window.alert('Error sending message: ' + error);
                                        });
                
                                        //liff.closeWindow();
                                    } else {
                                        const { from } = props.location.state || { from: { pathname: "/home" } };
                                        props.history.push(from);
                                    }
                                    */
                                },
                                (error) => {
                                    setIcon("far fa-question-circle");
                                    setErrMsg(error);
                                    setModal2(false);
                                    setModalError(true);
                                }
                            )









                    }
                    else {
                    
                        setIcon("far fa-question-circle");
                        setErrMsg('มีท่านอื่นจองเวลา '+ AppointTime + ' ไปแล้วก่อนหน้าท่าน กรุณาเลือกเวลาอื่นอีกครั้ง');
                        setModal2(false);
                        setModalError(true);

                        setRenderButton(resultValid.data);

                        setDisplayNoTime(resultValid.data != null && resultValid.data.length == 0);
                    }

                },
                (error) => {
                    alert(error);
                }
            );





        
    }


    //authenticationService.logout();

    const currentUser = authenticationService.currentUserValue;


    //check login
    if (!currentUser) {
        // not logged in so redirect to login page with the return url
        return <Redirect to={{ pathname: '/login', /*state: { from: props.location }*/ }} />
    }

    const onSubmit = values => {
        console.log(JSON.stringify(values));
    };

    const fetchHoliday = (yearMonth) => {
        fetch('/api/holiday/' + yearMonth, {
            method: 'GET',
            headers: authHeader()
        })
            .then(handleResponse)
            //.then(response => response.json())
            .then(
                (result) => {
                    setHolidays(result.data)
                },
                (error) => {
                    alert(error);
                }
       );
    };

    const handleCurrentDate = (dayAmt, unit) => {
        var curr = moment(currentDate).add(dayAmt, unit)
        setcurrentDate(curr);
        fetchHoliday(curr.format('YYYY/M'));
        return false;
    }

    const handleNavigate = (nextView, currentView, currDate) => {
        if (nextView == 'days') {
            setcurrentDate(currDate);
            fetchHoliday(currDate.format('YYYY/M'));
        }
        return nextView;
    }

    const handleHoliday = (txt) => {
        setHolidayText(txt);
        setModalHoliday(true);
    }

    function isDateValid(e, selectedDate) {
        var holiday = holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(e).format("YYYYMMDD"))
        //return current.day() !== 0 && current.day() !== 6;
        if (holiday != null)
            return false
        else
            return (e.day() !== 0 && e.day() !== 6 && e > (new Date()).setDate((new Date().getDate() - 1)))
    }

    function renderDay(props, currentDate, selectedDate) {
        var holiday = holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(currentDate).format("YYYYMMDD"))
        var hdt = (holiday != null) ? holiday.name : '';

        // Adds 0 to the days in the days view
        if ((props.className.indexOf('rdtDisabled') >= 0) && (currentDate.day() !== 0 && currentDate.day() !== 6 && currentDate > (new Date()).setDate((new Date().getDate() - 1)))) {
            props.className += ' text-danger';
            //return <td {...props} style={{ textDecoration: 'Line-Through' }}>{currentDate.date()}</td>;
            return <td >
                <button
                    onClick={e => handleHoliday(hdt)}
                    class="btn btn-danger btn-icon btn-round" style={{ background: 'red' }}
                >
                    <span className="text-white" style={{ textDecoration: 'Line-Through' }}>{currentDate.date()}</span>
                </button>
            </td>; 
        }
        else {
            return <td {...props}>{currentDate.date()}</td>;
        }
    }

    
    return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <IndexHeader  />
        <div className="main">
                  <div className="section">
                      <Container>
                          <Row>
                              <Col md="2">
                              </Col>
                              <Col md="8">
                                  <div className="hero-images-container " style={{ marginTop: '-20vh', maxWidth:'680px'}}>
                                      <img
                                          alt="..."
                                          src={require("assets/img/ts_logo_xl.png")}
                                      ></img>
                                  </div>
                              </Col>
                              <Col md="2">
                              </Col>
                          </Row>
                      </Container>
                  </div>  
        </div>
        
              <div className="section section-contact-us" style={{padding:0}}>
            <Container>
                      <h2 className="title text-center">กรุณาระบุข้อมูลเพื่อเป็นประโยชน์ในการรักษา</h2>
                      <p className="description text-center">กรอกข้อมูลเลย</p>



                      <Row>
                          <Col className="text-center ml-auto mr-auto" lg="6" md="8">

                                {(props.location.pathname == '/tele') ?
                                    <FormGroup check className="form-check-radio" inline
                                        style={{ padding: '0 40px', marginBottom: '10px' }}
                                    >
                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                            <Input
                                                defaultValue="option1"
                                                id="inlineRadio1"
                                                name="ServiceType"
                                                type="radio"
                                                checked={(ServiceType == 1 ? true : false)}
                                                onChange={e => handleServiceType(1)}
                                            ></Input>  พบแพทย์ <span className="form-check-sign"></span>
                                        </Label>
                                    </FormGroup> : <></>     
                                }

                                {(props.location.pathname == '/tele2') ?
                                <FormGroup check className="form-check-radio" inline
                                    style={{ padding: '0 40px', marginBottom: '10px' }}
                                >
                                    <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                        <Input
                                            defaultValue="option5"
                                            id="inlineRadio5"
                                            name="ServiceType"
                                            type="radio"
                                            checked={(ServiceType == 5 ? true : false)}
                                            onChange={e => handleServiceType(5)}
                                        ></Input>  พบแพทย์(2) <span className="form-check-sign"></span>
                                    </Label>
                                    </FormGroup> : <></>
                                }


                                {((isNewPatient)) ?
                                    <Alert color="warning">
                                       ผู้ป่วยใหม่ไม่สามารถรับยาเดิมได้ ต้องพบแพทย์ผ่าน Video Call เท่านั้น
                                    </Alert>:<></>
                                }
                                <FormGroup check className={(isNewPatient) ? "d-none form-check-radio" : "form-check-radio"} inline>
                                  <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                      <Input
                                          defaultValue="option2"
                                          id="inlineRadio2"
                                          name="ServiceType"
                                          type="radio"
                                          onChange={e => handleServiceType(2)}
                                      ></Input>  รับยาต่อเนื่อง <span className="form-check-sign"></span>
                                  </Label>
                              </FormGroup>
                          </Col>
                      </Row>

                      <Row>
                          <Col className="ml-auto mr-auto" lg="6" md="8">
                              <FormGroup
                                  style={{ padding: '0 0px', marginBottom: '10px', zIndex:1 }}
                                  className={
                                      "input-lg" + (dateFocus ? " input-group-focus" : "")
                                  }
                              >
                                  <i className="far fa-calendar-check fa-2x" style={{
                                      position: 'absolute',
                                      left: '12px',
                                      top: '10px',
                                      zIndex: 1,
                                    
                                  }}
                                  ></i>

                                    <Datetime
                                        renderYear={function (props, year, selectedDate) { return <td {...props}>{year + 543}</td>; }}
                                        isValidDate={isDateValid}
                                        renderDay={renderDay}
                                        onBeforeNavigate={(a, b, c) => handleNavigate(a, b, c)}
                                        onNavigateForward={(dayAmt, unit) => handleCurrentDate(dayAmt, unit)}
                                        onNavigateBack={(dayAmt, unit) => handleCurrentDate((-1 * dayAmt), unit)}
                                        inputProps={{
                                            name: "AppointDatetime", placeholder: "วันที่รับบริการ", readOnly: 'readonly'
                                            , style: {
                                                fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', background: '#ffffff', color: '#000000'
                                            }
                                        }}
                                        closeOnSelect={true}
                                        closeOnTab={true}
                                        dateFormat="D MMMM BBBB" timeFormat={false}
                                        //dateFormat="D MMMM BBBB" timeFormat="เวลา HH:mm น."
                                        //timeFormat={false}
                                        onFocus={() => setDateFocus(true)}
                                        onBlur={() => setDateFocus(false)}
                                        onChange={e => handleTimeSlot(e.format('YYYY-MM-DD'))}
                                        //onChange={e => setDate(e.format('YYYY-MM-DD HH:mm'))}              
                                        
                                  />
                              </FormGroup>
                               <Row style={{ margin: "0 -30px 0 -30px" }}>
                                    <Col className="text-center ml-auto mr-auto" xs="12">
                                        <Card body style={{ padding: 0 }} /*inverse style={{ background: "#1e71a1", width: "21rem" }}*/>
                                            <CardBody style={{ padding: "0 1rem" }}>
                                                {(displayNoTime) ?
                                                    <CardTitle tag="h4" style={{color:'red'}}>ไม่มีช่วงเวลาว่างในวันนี้</CardTitle>
                                                    :
                                                    <CardTitle tag="h4">{(AppointDate != null && AppointDate != "") ? "เลือกเวลานัดหมาย" : "เลือกวันที่นัดหมาย"}</CardTitle>
                                                }
                                            </CardBody>
                                            {buttonContent}
                                        </Card>
                                    </Col>
                                </Row>

                                <Modal
                                    className="modal-dialog modal-dialog-centered"
                                    toggle={() => setModalHoliday(false)}
                                    isOpen={modalHoliday}>

                                    <div className="modal-header" style={{ color: 'white', background: '#b92a34', paddingBottom: '10px' }}>
                                        <h5 className="modal-title" id="exampleModalLiveLabel">
                                            แจ้งเตือนวันหยุด
                                              </h5>
                                        <button
                                            aria-label="Close"
                                            className="close"
                                            type="button"
                                            onClick={() => setModalHoliday(false)}
                                        >
                                            <span aria-hidden={true} style={{ color: 'white' }}>×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <p>{holidayText}</p>
                                    </div>

                                </Modal>

                              <TSText name="LineID" placeholder="Line ID" onChange={e => setLine(e.target.value)} icon="fab fa-line fa-2x"/>
                              <input type="hidden" value={FullName} />

                              <TSText type="tel" maxLength="10" placeholder="โทรศัพท์" onChange={e => setPhone(e.target.value)} value={Phone} icon="fas fa-mobile-alt fa-2x" />

                              <div className="textarea-container" style={{ padding: 0 }}>
                                  <Label for="Address">ที่อยู่จัดส่งยา </Label>  <span style={{ marginLeft: 20 }} ><Input style={{ marginTop: 0, width: '20px', height: '20px', border:'1px solid black' }} type="checkbox" onChange={() => setIsCheckedAddress(!isCheckedAddress)} /> ใช้ที่อยู่ตอนลงทะเบียน</span> 
                                      {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามารถแก้ไขที่อยู่จัดส่งได้)*/}
                                  <Input
                                      id="Address"
                                      cols="80"
                                      name="ShippingAddress"
                                      placeholder="ที่อยู่จัดส่งยา"
                                      rows="4"
                                      type="textarea"
                                      style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                          //value={ShippingAddress}
                                      value={(isCheckedAddress) ? DefAddress : ShippingAddress}

                                      onChange={e => setAddress(e.target.value) }
                                      ></Input>
                              </div>
                   
                              <div className="textarea-container" style={{ padding: 0 }}>
                                  <Label for="Description">บอกเล่าอาการเบื้องต้น
                                  <Input
                                      id="Description"
                                      cols="80"
                                      name="Description"
                                          placeholder="บอกเล่าอาการเบื้องต้น"
                                      rows="4"
                                      type="textarea"
                                      style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                      onChange={e => setDescription(e.target.value)}
                                      ></Input>
                                  </Label>
                              </div>

                              {
                                  (files.length >= 1) ?
                                      <div className="clear-button">
                                          <Button
                                              block
                                              //className="btn-round"
                                              color="danger"
                                              href="#pablo"
                                              size="lg"
                                              style={{ fontSize: '1.2em' }}
                                              onClick={handleClear}
                                          >
                                              ล้างรูปใหม่
                                              </Button>
                                      </div> :
                                      ""
                              }
                              <section className="container text-center" style={{cursor: 'pointer', border: '1px dashed', padding: '20px 0px'}}>
                                  <div {...getRootProps({ className: 'dropzone' })}>
                                      <input /*name="fileUpload"*/ {...getInputProps()} /*onChange={handleChange}*/ />
                                      <p> <i className="now-ui-icons design_image"></i> แนบไฟล์รูปภาพรอยโรค </p>
                                      <p> รูปยาที่ต้องการรับยาต่อเนื่อง (Android เลือกทีละรูป)</p>
                                      <p> {(ServiceType == 1 ? "พบแพทย์ต้องแนบรูปอาการอย่างน้อย 4 รูป" : "")} </p>

                                  </div>
                                  <aside style={thumbsContainer}>
                                      {thumbs}
                                  </aside>
                              </section>





                              <div className="send-button">
                                  <Button
                                      block
                                      className="btn-round"
                                      color="info"
                                      href="#pablo"
                                      size="lg"
                                      style={{ fontSize: '1.2em' }}
                                      onClick={handleSubmit}
                                  >
                                      ลงทะเบียน{ServiceTypeText}
                                  </Button>

                                  {/* Note */}

                                  <Modal
                                      className="modal-dialog modal-dialog-centered"
                                      toggle={() => setModalNote(false)}
                                      isOpen={modalNote}>

                                      <div className="modal-header" style={{ color: 'white', background: '#b92a34', paddingBottom: '10px' }}>
                                          <h5 className="modal-title" id="exampleModalLiveLabel">
                                              แจ้งเพื่อทราบ
                                              </h5>
                                          <button
                                              aria-label="Close"
                                              className="close"
                                              type="button"
                                              onClick={() => setModalNote(false)}
                                          >
                                              <span aria-hidden={true}>×</span>
                                          </button>
                                      </div>
                                      <div className="modal-body">
                                          <p>เมนูนี้คือบริการปรึกษาทางไกลและรับยาทางไปรษณีย์</p>
                                          <p>หากต้องการนัดหมาย/จองคิว เพื่อมารับการรักษาที่โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จ.ตรัง กรุณาเลือกเมนู "นัดหมาย"</p>
                                      </div>
                                      <div className="modal-footer">
                                          <Button
                                              color="primary"
                                              type="button"
                                              onClick={() => setModalNote(false)}
                                          >
                                              ตกลง
                                          </Button>
                                      </div>
                                  </Modal>

                                  {/* Confirm */}
                                  <Modal
                                      modalClassName="modal-mini modal-info"
                                      toggle={() => setModal2(false)}
                                      isOpen={modal2}
                                  >
                                      <div className="modal-header justify-content-center">
                                          <div className="modal-profile">
                                              <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                                          </div>
                                      </div>
                                      <ModalBody>
                                          <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? "ยืนยันการบันทึกข้อมูล" : "กำลังบันทึกข้อมูล"}</p>
                                          <p>ท่านตรวจสอบที่อยู่จัดส่งถูกต้องแล้วใช่หรือไม่</p>
                                            {<p className="btn-neutral" style={{
                                                fontSize:'0.9rem'}}>{(isCheckedAddress) ? DefAddress : ShippingAddress}</p>}
                                          <p>  </p>
                                      </ModalBody>
                                      <div className="modal-footer">
                                          <Button
                                              className="btn-neutral"
                                              color="link"
                                              type="button"
                                              onClick={() => setModal2(false)}
                                          >
                                              ยกเลิก
                                      </Button>

                                          <Button
                                              className="btn-neutral"
                                              color="link"
                                              type="button"
                                              onClick={handleConfirm}
                                              disabled={icon == "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                          //onClick={() => setModal2(false)}
                                          >
                                              ยืนยัน
                                      </Button>



                                      </div>
                                  </Modal>


                                  {/* Error */}
                                  <Modal
                                      modalClassName="modal-mini modal-danger"
                                      toggle={() => setModalError(false)}
                                      isOpen={modalError}
                                  >
                                      <div className="modal-header justify-content-center">
                                          <div className="modal-profile">
                                              <i className="fa fa-times" style={{ color: 'red', fontSize: '2em' }}></i>
                                          </div>
                                      </div>
                                      <ModalBody>
                                          <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                          <p> {errMsg} </p>
                                      </ModalBody>
                                      <div className="modal-footer justify-content-center">
                                          <Button
                                              className="btn-neutral"
                                              color="neutral"
                                              type="button"
                                              onClick={() => setModalError(false)}
                                          >
                                              ตกลง
                                      </Button>
                                      </div>
                                  </Modal>

                              </div>
                          </Col>
                      </Row>
                  </Container>
        </div>
        <DefaultFooter />
      </div>
    </>
  );
}

export default TelePage;
